import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { DashboardService } from '../../services/dashboard.service';
import { HeaderPopoverService } from '../../services/header-popover.service';
import { NotificationData, PaginationInfo } from '../../../shared/ui/notification-list/notification-list.component';
import { PopoverComponent } from '../../../shared/ui/popover/popover.component';

@Component({
  selector: 'app-notification-container',
  templateUrl: './notification-container.component.html',
  styleUrls: ['./notification-container.component.scss']
})
export class NotificationContainerComponent implements OnInit, OnDestroy {
  @ViewChild(PopoverComponent) popoverRef: PopoverComponent;

  notificationsCount: number = 0;
  notifications: NotificationData[] = [];
  paginationInfo: PaginationInfo = {
    pageSize: 5,
    pageNumber: 0,
    totalElements: 0,
    totalPages: 0,
    first: true,
    last: true
  };
  isLoading: boolean = false;

  private readonly pageSize = 5;
  private currentPage: number = 0;
  private countSub: Subscription;
  private listSub: Subscription;
  private popoverSub: Subscription;

  constructor(
    private dashboardService: DashboardService,
    private headerPopoverService: HeaderPopoverService
  ) {}

  ngOnInit() {
    this.loadCount();
    this.popoverSub = this.headerPopoverService.activePopover$.subscribe((name: string) => {
      if (name !== 'notification' && this.popoverRef) {
        this.popoverRef.close();
      }
    });
  }

  loadCount() {
    this.countSub = this.dashboardService.getNotificationsCount().subscribe(
      (count) => {
        this.notificationsCount = count;
      },
      () => {}
    );
  }

  onPopoverShow() {
    this.headerPopoverService.open('notification');
    this.loadNotifications(0);
  }

  loadNotifications(page: number) {
    this.isLoading = true;
    this.currentPage = page;
    const params = { page: page, size: this.pageSize };

    this.listSub = this.dashboardService.getNotifications(params).subscribe(
      (data) => {
        this.notifications = data && data.content ? data.content : [];
        this.paginationInfo = {
          pageSize: data.size,
          pageNumber: data.number,
          totalElements: data.totalElements,
          totalPages: data.totalPages,
          first: data.first,
          last: data.last
        };
        this.isLoading = false;
        this.markAsViewed(this.notifications);
      },
      () => {
        this.isLoading = false;
      }
    );
  }

  markAsViewed(items: NotificationData[]) {
    const unviewed = items
      .filter(n => !n.viewed)
      .map(n => ({ id: n.id, viewed: true }));

    if (unviewed.length) {
      this.dashboardService.updateNotification(unviewed).subscribe(
        () => {
          this.loadCount();
        },
        () => {}
      );
    }
  }

  onPageChange(page: number) {
    this.loadNotifications(page);
  }

  onRemoveNotification(id: number) {
    const body = { id: id, viewed: true };
    this.dashboardService.postDeleteNotification(body).subscribe(
      () => {
        if (this.notifications.length === 1 && this.currentPage > 0) {
          this.loadNotifications(this.currentPage - 1);
        } else {
          this.loadNotifications(this.currentPage);
        }
        this.loadCount();
      },
      () => {}
    );
  }

  ngOnDestroy() {
    if (this.countSub) {
      this.countSub.unsubscribe();
    }
    if (this.listSub) {
      this.listSub.unsubscribe();
    }
    if (this.popoverSub) {
      this.popoverSub.unsubscribe();
    }
  }
}
